export const KEYS = ["cookie", "sec-ch-ua", "user-agent", "version"];
export const LIST_KEYS = ["ban_illusts", "ban_user", "skip_words"];